import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FooterService } from '../footer.service';
import { FooterTypeEnum } from '../../../core/enums/generated/FooterTypeEnum';

@Component({
	selector: 'pcg-view-terms-conditions-footer',
	templateUrl: './view-terms-conditions-footer.component.html',
	styleUrl: './view-terms-conditions-footer.component.scss',
	standalone: true,
	imports: [],
})
export class ViewTermsConditionsFooterComponent implements OnInit {
	footerService = inject(FooterService);
	title = inject(Title);

	footerDescription!: string;

	ngOnInit() {
		this.title.setTitle('Terms and Conditions');
		this.footerService.getFooterItem(FooterTypeEnum.TermsConditions).subscribe((vm: any) => {
			this.footerDescription = vm?.footerDescription;
		});
	}
}
